/**
 * @file trait
 * @author 丁聪
 */

import React, { Component } from 'react'

import './index.scss'


class Trait extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() { }

  render() {
    let introlist = [
      {
        title: '科学系统的课程规划',
        text: '我们的课程设计，充分考虑了海外华侨华人子女的中文学习需求和学习特点。除了拼音、识字相关的短期课程，更有大量系统性的长期课程，帮助孩子综合提高中文运用能力。',
        img: `//cdn.ihatoo.com/hatu-official/course/f2-icon-ke.png`
      },
      {
        title: '丰富优质的课程内容',
        text: '我们的课程涵盖了“中文基础类、技能训练类、文化兴趣类”三大类别。既能满足学员提升中文表达能力的需求，也能满足专门提升中文“阅读”和“写作”能力,以及了解更多中华传统文化的需求。',
        img: `//cdn.ihatoo.com/hatu-official/course/f2-icon-qm.png`
      },
      {
        title: '多样有趣的互动形式',
        text: '我们的课程充分利用多媒体技术：大量精美的图片，音频、视频和GIF动图等多种展现形式，结合有趣的交互型游戏，让学生充分参与到课堂中，使教学更生动、练习更有趣！',
        img: `//cdn.ihatoo.com/hatu-official/course/f2-icon-ff.png`
      },
    ]
    return (
      <div id="trait">
        <div className="trait-first">
          <div className="inner-title">课程特色</div>
          <ul className="intro">
            {introlist.map((item, index) => (
              <li key={'intro-' + index}>
                <div className="img" style={{ background: `url(${item.img}) no-repeat top` }}></div>
                <div className="title"> <p className="item-title">{item.title}</p>
                  <p className="text">{item.text}</p>
                </div>
                {/* <div className="intro">{item.intro}</div> */}
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  }
}

export default Trait